<template>
  <div class="section-title">
    <h3 @click="clickChange">{{ row.name }}</h3>
    <p v-if="subCate && subCate.length">
      <em class="iconfont icon-arrow-right-filling"></em>
      <template v-for="(item,index) in subCate">
        <router-link 
          :key="index" 
          :to="{
            path: row.path,
            query:{
              cate: row.id,
              'subId':item.id
            }
          }" 
          v-if="index<12 && item.name!=row.name"
        >
          <span>{{item.name}}</span>
        </router-link>
      </template>
    </p>
    <div class="more-btn" @click="clickChange">
      <em>更多</em>
      <span class="iconfont icon-arrow-right"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'subHeader',
  props: {
    list: Array,
    baseRow: Object,
  },
  data(){
    return {
      row: {},
      subCate: []
    }
  },
  watch:{
    list(newval){
      newval && this.initPage()
    }
  },
  mounted(){
    this.initPage()
  },
  methods:{
    initPage() {
      this.row = this.baseRow || {}
      this.subCate = this.list || []
    },
    // 点击切换
    clickChange(){
      this.$router.push({
        path: this.baseRow.path + '?cate=' + this.baseRow.id,
      })
    }

  }
}
</script>